import { useQuery, useMutation } from "react-query";
import { queryClient } from "../../libs/react-query";
import { GET_TOURIST_BY_NATIONALITY, RETRIEVE_TOURIST_BY_NATIONALITY } from "../../constants/queryKeys";
import { addTouristNationality, deleteTouristNationality, getRetrieveTouristNationalities, getTouristNationalities, importExcelTouristNationality } from "../apiClient/touristNationality";

const invalidateTouristNationalityQuery = () => {
	queryClient.invalidateQueries(GET_TOURIST_BY_NATIONALITY);
};
const useGetTouristNationalities = ({ payload, config }) => {
	return useQuery([GET_TOURIST_BY_NATIONALITY,payload], () => getTouristNationalities(payload), config);
};
const useAddTouristNationality = (options) => {
	return useMutation((payload) => addTouristNationality(payload), options);
};
const useDeleteTouristNationality = (options) => {
	return useMutation((payload) => deleteTouristNationality(payload), options);
};
const useImportExcelTouristNationality = (options) => {
	return useMutation((payload) => importExcelTouristNationality(payload), options);
};
const useRetrieveTouristNationalities = ({ payload, config }) => {
	return useQuery([RETRIEVE_TOURIST_BY_NATIONALITY, payload], () => getRetrieveTouristNationalities(payload), config);
};


export { useImportExcelTouristNationality,useDeleteTouristNationality, useAddTouristNationality, useRetrieveTouristNationalities, invalidateTouristNationalityQuery, useGetTouristNationalities };
